import { Skeleton } from "@/components/ui/skeleton";

export function FinanceOverviewSkeleton() {
	return (
		<div className="flex flex-col gap-5 pt-5">
			<FinanceMetricsSkeleton />
			<FinanceListSkeleton />
		</div>
	);
}

export function FinanceMetricsSkeleton() {
	return (
		<div className="grid gap-3 pt-5 sm:grid-cols-3">
			<Skeleton className="h-32 rounded-lg" />
			<Skeleton className="h-32 rounded-lg" />
			<Skeleton className="h-32 rounded-lg" />
		</div>
	);
}

export function ReconciliationSummarySkeleton() {
	return <Skeleton className="mt-5 h-20 w-full rounded-lg" />;
}

export function FinanceListSkeleton() {
	return (
		<div className="mt-5 grid gap-5">
			{[1, 2].map((group) => (
				<div key={group} className="grid gap-2 sm:grid-cols-[92px_minmax(0,1fr)]">
					<Skeleton className="h-3 w-16" />
					<div className="grid gap-2 border-l border-border pl-4">
						{[1, 2].map((row) => (
							<div key={row} className="surface-panel p-4">
								<div className="flex items-center gap-3">
									<Skeleton className="size-4 rounded-full" />
									<Skeleton className="h-3 flex-1" />
									<Skeleton className="h-3 w-24" />
								</div>
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	);
}
